import { GET_REVIEW_URL, UPDATE_USER_PROFILE_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getReviewList = (page, per_page) => onResponse => {
    try {
        axiosInstance.get(GET_REVIEW_URL + '?page=' + page + '&per_page=' + per_page)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};